/*
Copyright 2025 iodyne.  All rights reserved.
iodyne Proprietary/Confidental: INTERNAL USE ONLY
*/

import i18next from 'i18next';
import { initReactI18next } from 'react-i18next/initReactI18next';
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { getOptions, languages } from './settings'

const RUNS_ON_SERVER_SIDE = typeof window === 'undefined';

const initPromise = i18next 
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(resourcesToBackend((language:any, namespace:any) => import(`./locales/${language}/${namespace}.json`)))
  .init({
    ...getOptions(),
    lng: undefined, // let detect the language on client side
    detection: {
      order: ['path', 'navigator'],
    },
    preload: RUNS_ON_SERVER_SIDE ? languages : []
  })

export { initPromise }
export default i18next;